<template>
  <page-error title="500" :message="message" :error="error"></page-error>
</template>

<script>
import PageError from "@/views/PageError";
export default {
  name: "Page500",
  components: {
    PageError
  },
  props: {
    message: String,
    error: Error
  }
};
</script>
